import { useState, useEffect, useRef } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

import img3 from "../assets/Rectangle 25.png";
import img6 from "../assets/Annapurna.png";
import img7 from "../assets/dataevolve office.png";

import logoDataevolve from "../assets/delogosvg.png";
import logoAnnapurna from "../assets/ANR's_Annapurna_Studios_Logo.png";

/* ── spectacles cursor ── */
const SPECS_CURSOR = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='28' viewBox='0 0 48 28'%3E%3Crect x='1' y='4' width='18' height='18' rx='9' ry='9' fill='none' stroke='%231a1a1a' stroke-width='2.5'/%3E%3Crect x='29' y='4' width='18' height='18' rx='9' ry='9' fill='none' stroke='%231a1a1a' stroke-width='2.5'/%3E%3Cpath d='M19 13 L29 13' stroke='%231a1a1a' stroke-width='2.5' stroke-linecap='round'/%3E%3Cpath d='M1 13 L0 8' stroke='%231a1a1a' stroke-width='2' stroke-linecap='round'/%3E%3Cpath d='M47 13 L48 8' stroke='%231a1a1a' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E`;

const sharedStyle = `
  @import url('https://fonts.googleapis.com/css2?family=Caveat:wght@400;600&family=DM+Sans:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; scroll-behavior: smooth; margin: 0; padding: 0; }

  body {
    background: #fafafa;
    background-image: linear-gradient(rgba(0,0,0,0.045) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.045) 1px, transparent 1px);
    background-size: 32px 32px;
    cursor: url("${SPECS_CURSOR}") 24 14, auto;
    font-family: 'DM Sans', sans-serif;
  }

  a, button, [role="button"], .nav-link {
    cursor: url("${SPECS_CURSOR}") 24 14, pointer;
  }

  .handwritten { font-family: 'Caveat', cursive; }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeScale {
    from { opacity: 0; transform: scale(0.96) translateY(14px); }
    to   { opacity: 1; transform: scale(1) translateY(0); }
  }
  @keyframes floatPin {
    0%, 100% { transform: translateY(0) rotate(-12deg); }
    50%      { transform: translateY(-7px) rotate(-8deg); }
  }
  @keyframes ringPulse {
    0%   { box-shadow: 0 0 0 0 rgba(34,197,94,0.55); }
    70%  { box-shadow: 0 0 0 12px rgba(34,197,94,0); }
    100% { box-shadow: 0 0 0 0 rgba(34,197,94,0); }
  }
  @keyframes blobMove {
    0%, 100% { transform: translate(0,0) scale(1); }
    33%      { transform: translate(20px,-16px) scale(1.06); }
    66%      { transform: translate(-14px,12px) scale(0.96); }
  }

  .anim-d0 { animation: fadeScale 0.7s 0.00s cubic-bezier(.22,.68,0,1.1) both; }
  .anim-d1 { animation: fadeUp 0.65s 0.18s ease both; }
  .anim-d2 { animation: fadeUp 0.65s 0.30s ease both; }
  .anim-d3 { animation: fadeUp 0.65s 0.42s ease both; }

  .reveal { opacity: 0; transform: translateY(28px); transition: opacity 0.7s ease, transform 0.7s ease; }
  .reveal.visible { opacity: 1; transform: translateY(0); }

  .sec-label {
    font-size: 10px; font-weight: 700;
    letter-spacing: 0.22em; text-transform: uppercase;
    color: #aaa; margin-bottom: 28px; display: block;
  }

  .divider { border: none; border-top: 1px solid #ebebeb; margin: 0; }

  /* ── background blobs for vibrancy ── */
  .blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(50px);
    opacity: 0.35;
    pointer-events: none;
    z-index: 0;
    animation: blobMove 9s ease-in-out infinite;
  }

  /* ── HERO — editorial split ── */
  .hero-wrap { position: relative; overflow: hidden; }

  .hero-bg-name {
    position: absolute;
    top: -34px;
    left: -6px;
    font-size: clamp(70px, 11vw, 150px);
    font-weight: 800;
    letter-spacing: -0.04em;
    color: transparent;
    -webkit-text-stroke: 1.4px rgba(245,217,48,0.5);
    line-height: 1;
    white-space: nowrap;
    z-index: 0;
    pointer-events: none;
    user-select: none;
  }

  .hero-photo-frame { position: relative; z-index: 2; }
  .hero-photo-inner {
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    box-shadow: 0 30px 70px rgba(245,217,48,0.28), 0 10px 24px rgba(0,0,0,0.15);
    border: 8px solid #fff;
  }
  .hero-photo-inner img { transition: transform 0.6s cubic-bezier(.22,.68,0,1.1); display:block; }
  .hero-photo-frame:hover .hero-photo-inner img { transform: scale(1.05); }

  .hero-sticker {
    position: absolute;
    top: -14px;
    right: -22px;
    background: #f5d930;
    color: #1a1a1a;
    border-radius: 50%;
    width: 84px; height: 84px;
    display: flex; align-items: center; justify-content: center;
    text-align: center;
    transform: rotate(-12deg);
    box-shadow: 0 10px 26px rgba(245,217,48,0.55);
    animation: floatPin 5s ease-in-out infinite;
    z-index: 6;
    border: 3px solid #fff;
  }
  .hero-sticker span {
    font-family: 'DM Sans', sans-serif;
    font-size: 9.5px;
    font-weight: 800;
    letter-spacing: .04em;
    line-height: 1.3;
    text-transform: uppercase;
  }

  .status-dot {
    width: 8px; height: 8px;
    border-radius: 50%;
    background: #22c55e;
    display: inline-block;
    animation: ringPulse 2s infinite;
  }

  .hero-vert-label {
    writing-mode: vertical-rl;
    text-orientation: mixed;
    transform: rotate(180deg);
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .18em;
    text-transform: uppercase;
    color: #c9a800;
    white-space: nowrap;
  }

  .hero-stat {
    border-left: 2px solid #f5d930;
    padding-left: 14px;
  }
  .hero-stat-num {
    font-size: 26px;
    font-weight: 800;
    color: #1a1a1a;
    letter-spacing: -0.02em;
    line-height: 1;
    display: block;
  }
  .hero-stat-label {
    font-size: 10.5px;
    color: #999;
    letter-spacing: 0.02em;
    margin-top: 4px;
    display: block;
  }

  /* ── Experience card ── */
  .exp-card {
    background: #fff;
    border-radius: 16px;
    padding: 28px;
    margin-bottom: 14px;
    border: 1px solid rgba(0,0,0,0.07);
    box-shadow: 0 2px 12px rgba(0,0,0,0.04);
    transition: box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease;
    position: relative;
    overflow: hidden;
  }
  .exp-card::before {
    content: '';
    position: absolute;
    top: 0; left: 0; bottom: 0;
    width: 3px;
    background: linear-gradient(180deg, #f5d930, #ffb84d);
    opacity: 0;
    transition: opacity 0.25s ease;
  }
  .exp-card:hover { box-shadow: 0 10px 32px rgba(245,217,48,0.18); transform: translateY(-3px); border-color: rgba(245,217,48,0.3); }
  .exp-card:hover::before { opacity: 1; }
  .exp-photo { width: 150px; height: 110px; border-radius: 10px; overflow: hidden; flex-shrink: 0; box-shadow: 0 4px 14px rgba(0,0,0,0.10); }
  .exp-photo img { transition: transform 0.4s ease; width: 100%; height: 100%; object-fit: cover; }
  .exp-photo:hover img { transform: scale(1.06); }

  /* ── Tool card ── */
  .tool-card {
    background: #fff;
    border-radius: 14px;
    padding: 20px 22px;
    border: 1px solid rgba(0,0,0,0.07);
    box-shadow: 0 2px 10px rgba(0,0,0,0.03);
    transition: box-shadow 0.22s ease, transform 0.22s ease, border-color 0.22s ease;
  }
  .tool-card:hover { box-shadow: 0 10px 28px rgba(245,217,48,0.2); transform: translateY(-3px) scale(1.015); border-color: rgba(245,217,48,0.35); }

  .t-icon {
    width: 34px; height: 34px;
    border-radius: 50%;
    border: 2px solid #fff;
    margin-right: -7px;
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 1px 5px rgba(0,0,0,0.13);
    overflow: hidden;
    background: #f5f5f5;
    transition: transform 0.25s cubic-bezier(.22,.68,0,1.3);
  }
  .tool-card:hover .t-icon { transform: translateY(-3px); }
  .tool-card:hover .t-icon:nth-child(2) { transform: translateY(-5px); transition-delay: 0.04s; }
  .tool-card:hover .t-icon:nth-child(3) { transform: translateY(-3px); transition-delay: 0.08s; }
  .t-icon img { width: 20px; height: 20px; object-fit: contain; }

  .tools-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 12px; }

  .nav-link {
    font-size: 11px; font-weight: 600;
    letter-spacing: 0.14em; text-transform: uppercase;
    color: #1a1a1a; text-decoration: none;
    opacity: 0.65; transition: opacity 0.15s;
  }
  .nav-link:hover { opacity: 1; }

  .progress-bar { transition: width 0.3s ease; }

  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-track { background: #fff; }
  ::-webkit-scrollbar-thumb { background: #f5d930; border-radius: 4px; }

  .social-pill {
    display: inline-flex; align-items: center;
    border: 1.5px solid #1a1a1a; border-radius: 999px;
    padding: 7px 20px; font-size: 13px; font-weight: 500;
    color: #1a1a1a; text-decoration: none;
    transition: background 0.18s, color 0.18s, border-color 0.18s, transform 0.18s;
    font-family: 'DM Sans', sans-serif;
  }
  .social-pill:hover { background: #f5d930; border-color: #f5d930; color: #1a1a1a; transform: translateY(-2px); }

  /* ── RESPONSIVE ── */
  @media (max-width: 768px) {
    .hero-bg-name  { display: none !important; }
    .about-hero    { grid-template-columns: 1fr !important; gap: 28px !important; }
    .about-photo-col { display: flex; flex-direction: column; align-items: center; }
    .hero-photo-frame { max-width: 240px; width: 100%; }
    .hero-sticker  { width: 64px !important; height: 64px !important; right: -8px !important; }
    .hero-sticker span { font-size: 8px !important; }
    .hero-vert-label { display: none !important; }
    .exp-card      { padding: 20px 18px !important; }
    .exp-photo     { display: none !important; }
    .connect-grid  { grid-template-columns: 1fr !important; }
    .social-cluster { position: relative !important; width: 100% !important; height: auto !important; display: flex !important; flex-wrap: wrap !important; gap: 10px !important; }
    .social-pill   { position: relative !important; top: auto !important; right: auto !important; }
    .main-pad      { padding: 0 20px !important; }
    .tools-grid    { grid-template-columns: repeat(2,1fr) !important; }
    .hero-stats-row { flex-wrap: wrap !important; gap: 24px !important; }
  }
  @media (max-width: 420px) {
    .tools-grid    { grid-template-columns: 1fr !important; }
  }
`;

/* ── scroll reveal hook ── */
function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { el.classList.add("visible"); obs.disconnect(); } },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

/* ─────────────────────────────────────────────
   Tool icon URLs
───────────────────────────────────────────── */
const ICON = {
  figma:      "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/figma.svg",
  xd:         "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/adobexd.svg",
  framer:     "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/framer.svg",
  lottie:     "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/lottiefiles.svg",
  afterfx:    "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/adobeaftereffects.svg",
  premiere:   "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/adobepremierepro.svg",
  html5:      "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/html5.svg",
  css3:       "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/css3.svg",
  react:      "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/react.svg",
  photoshop:  "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/adobephotoshop.svg",
  illustrator:"https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/adobeillustrator.svg",
  vscode:     "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/visualstudiocode.svg",
  miro:       "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/miro.svg",
  notion:     "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/notion.svg",
};

const ICON_BG = {
  figma:       "#FF7262",
  xd:          "#FF61F6",
  framer:      "#0099FF",
  lottie:      "#00DDB3",
  afterfx:     "#9999FF",
  premiere:    "#9999FF",
  html5:       "#E44D26",
  css3:        "#264DE4",
  react:       "#149ECA",
  photoshop:   "#31A8FF",
  illustrator: "#FF9A00",
  vscode:      "#007ACC",
  miro:        "#FFD02F",
  notion:      "#1A1A1A",
};

/* ── Tool groups — matches the icons actually listed in `tools` ── */
const toolGroups = [
  {
    category: "Wireframing",
    tools: "Figma, Adobe XD",
    icons: [
      { key: "figma",  url: ICON.figma,  bg: ICON_BG.figma,  alt: "Figma"    },
      { key: "xd",     url: ICON.xd,     bg: ICON_BG.xd,     alt: "Adobe XD" },
    ],
  },
  {
    category: "Prototyping & Animation",
    tools: "Framer, Jitter, LottieFiles",
    icons: [
      { key: "framer", url: ICON.framer, bg: ICON_BG.framer, alt: "Framer"      },
      { key: "jitter", url: null,        bg: "#1A1A1A",      alt: "Jitter", label: "Ji" },
      { key: "lottie", url: ICON.lottie, bg: ICON_BG.lottie, alt: "LottieFiles" },
    ],
  },
  {
    category: "Video Editing",
    tools: "Premiere Pro, After Effects",
    icons: [
      { key: "premiere", url: ICON.premiere, bg: ICON_BG.premiere, alt: "Premiere Pro"  },
      { key: "afterfx",  url: ICON.afterfx,  bg: ICON_BG.afterfx,  alt: "After Effects" },
    ],
  },
  {
    category: "Coding Languages",
    tools: "HTML, CSS, React.js",
    icons: [
      { key: "html5", url: ICON.html5, bg: ICON_BG.html5, alt: "HTML5"    },
      { key: "css3",  url: ICON.css3,  bg: ICON_BG.css3,  alt: "CSS3"     },
      { key: "react", url: ICON.react, bg: ICON_BG.react, alt: "React.js" },
    ],
  },
  {
    category: "Graphic Designing",
    tools: "Photoshop, Illustrator",
    icons: [
      { key: "photoshop",   url: ICON.photoshop,   bg: ICON_BG.photoshop,   alt: "Photoshop"   },
      { key: "illustrator", url: ICON.illustrator, bg: ICON_BG.illustrator, alt: "Illustrator" },
    ],
  },
  {
    category: "Other Tools",
    tools: "VS Code, Miro, Notion",
    icons: [
      { key: "vscode", url: ICON.vscode, bg: ICON_BG.vscode, alt: "VS Code" },
      { key: "miro",   url: ICON.miro,   bg: ICON_BG.miro,   alt: "Miro"    },
      { key: "notion", url: ICON.notion, bg: ICON_BG.notion, alt: "Notion"  },
    ],
  },
];

function ToolIcon({ url, bg, alt, label }) {
  return (
    <div className="t-icon" style={{ background: bg }} title={alt}>
      {url ? (
        <img src={url} alt={alt} style={{ width: 18, height: 18, objectFit: "contain", filter: "brightness(0) invert(1)" }} />
      ) : (
        <span style={{ fontSize: 9, fontWeight: 700, color: "#fff", letterSpacing: "-0.02em" }}>{label}</span>
      )}
    </div>
  );
}

function ToolCard({ category, tools, icons }) {
  return (
    <div className="tool-card">
      <div style={{ display: "flex", marginBottom: 14 }}>
        {icons.map((ic) => (
          <ToolIcon key={ic.key} url={ic.url} bg={ic.bg} alt={ic.alt} label={ic.label} />
        ))}
      </div>
      <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, fontWeight: 600, color: "#1a1a1a", marginBottom: 4, lineHeight: 1.35 }}>
        {tools}
      </p>
      <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, color: "#aaa", letterSpacing: "0.02em" }}>
        {category}
      </p>
    </div>
  );
}

function ExpRow({ logo, role, company, period, photo, description }) {
  const ref = useReveal();
  return (
    <div ref={ref} className="reveal exp-card">
      <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 28, alignItems: "center" }}>
        <div>
          <div style={{ marginBottom: 16, minHeight: 38, display: "flex", alignItems: "center" }}>
            {logo ? (
              <img src={logo} alt={company} style={{ height: 30, maxWidth: 170, objectFit: "contain", objectPosition: "left center" }} />
            ) : (
              <span style={{ display: "inline-block", background: "#f0f0f0", borderRadius: 8, padding: "5px 14px", fontFamily: "'DM Sans',sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", color: "#444", textTransform: "uppercase" }}>
                {company}
              </span>
            )}
          </div>
          <h3 style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 18, fontWeight: 600, color: "#1a1a1a", lineHeight: 1.35, marginBottom: 5, letterSpacing: "-0.01em" }}>
            {role}
          </h3>
          <span style={{ display: "inline-block", fontFamily: "'DM Sans',sans-serif", fontSize: 11, color: "#999", background: "#fff8df", borderRadius: 999, padding: "3px 12px", letterSpacing: "0.02em", marginBottom: description ? 14 : 0, border: "1px solid #f5e9b0" }}>
            {period}
          </span>
          {description && (
            <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, color: "#888", lineHeight: 1.75, marginTop: 10, maxWidth: 460 }}>
              {description}
            </p>
          )}
        </div>
        {photo && (
          <div className="exp-photo">
            <img src={photo} alt={role} />
          </div>
        )}
      </div>
    </div>
  );
}

/* ── Main ── */
export default function About() {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const el = document.documentElement;
      setScrollProgress((el.scrollTop / (el.scrollHeight - el.clientHeight)) * 100);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const storyRef   = useReveal();
  const toolsRef   = useReveal();
  const connectRef = useReveal();

  return (
    <div style={{ background: "#fafafa", minHeight: "100vh", backgroundImage: "linear-gradient(rgba(0,0,0,0.045) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.045) 1px, transparent 1px)", backgroundSize: "32px 32px" }}>
      <style>{sharedStyle}</style>

      <div style={{ position: "fixed", top: 0, left: 0, right: 0, height: 3, background: "rgba(0,0,0,0.05)", zIndex: 100 }}>
        <div className="progress-bar" style={{ height: "100%", background: "#f5d930", width: `${scrollProgress}%` }} />
      </div>

      <Navbar />

      <main className="main-pad" style={{ maxWidth: 860, margin: "0 auto", padding: "0 40px 0" }}>

        {/* ══ HERO — editorial split ══ */}
        <section className="hero-wrap" style={{ paddingTop: 76, paddingBottom: 76, position: "relative" }}>

          {/* vibrant background blobs */}
          <div className="blob" style={{ width: 280, height: 280, top: -60, right: -60, background: "#f5d930" }} />
          <div className="blob" style={{ width: 220, height: 220, bottom: 20, left: -40, background: "#ffb84d", animationDelay: "2s" }} />

          {/* giant outline word behind everything */}
          <div className="hero-bg-name anim-d0">DESIGN</div>

          <div className="about-hero" style={{ display: "grid", gridTemplateColumns: "44px 220px 1fr", gap: 32, alignItems: "flex-start", position: "relative", zIndex: 1 }}>

            <div style={{ display: "flex", justifyContent: "center", paddingTop: 18 }}>
              <span className="hero-vert-label anim-d1">Portfolio — 2025</span>
            </div>

            <div className="about-photo-col">
              <div className="anim-d0 hero-photo-frame">
                <div className="hero-photo-inner" style={{ aspectRatio: "3/4" }}>
                  <img
                    src={img3}
                    alt="Satish Dandabathula"
                    style={{ width: "100%", height: "100%", objectFit: "cover", filter: "grayscale(15%)" }}
                  />
                </div>
                
              </div>

             
            </div>

            <div style={{ paddingTop: 4 }}>
              <h1
                className="anim-d1 handwritten"
                style={{
                  fontSize: "clamp(36px,5.5vw,52px)",
                  color: "#1a1a1a",
                  lineHeight: 1.1,
                  marginBottom: 8,
                  fontWeight: 900,
                }}
              >
                DESIGNING SIMPLICITY IN<br />
                <span style={{ color: "#d4a900" }}>COMPLEX SYSTEMS</span>
              </h1>
              <p className="anim-d1" style={{ fontSize: 13, color: "#aaa", marginBottom: 30, letterSpacing: ".01em" }}>
               
              </p>

         

              <div className="anim-d3" style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                <p style={{ fontSize: 14, color: "#555", lineHeight: 1.85, fontFamily: "'DM Sans',sans-serif" }}>
                  My journey into UX didn't begin with designing products — it began with visual storytelling.
                  As a Visual Effects Artist, I learned that even the smallest visual detail could influence how people
                  experience a story. Working closely with artists, supervisors, and production teams taught me precision,
                  collaboration, and the importance of continuous feedback.
                </p>
                <p style={{ fontSize: 14, color: "#555", lineHeight: 1.85, fontFamily: "'DM Sans',sans-serif" }}>
                  Over time, I found myself becoming more interested in <strong>why</strong> experiences work than simply
                  how they look. That curiosity led me to transition into UX design, where I could combine creativity,
                  systems thinking, and problem solving to design products that create real value for both users and businesses.
                </p>
                <p style={{ fontSize: 14, color: "#555", lineHeight: 1.85, fontFamily: "'DM Sans',sans-serif" }}>
                  For the past four years, I've been designing enterprise products across cloud management, industrial safety,
                  and digital public services. What I enjoy most is simplifying complex workflows, collaborating with
                  cross-functional teams, and transforming complicated systems into intuitive experiences that people can
                  use with confidence.
                </p>
              </div>

             
             
            </div>
          </div>
        </section>

        <hr className="divider" />

        {/* ══ CURRENTLY ══ */}
        <section ref={storyRef} className="reveal" style={{ paddingTop: 48 }}>
          <span className="sec-label">Currently</span>
          <ExpRow
            logo={logoDataevolve}
            company="Dataevolve"
            role="UI/UX Designer at Dataevolve Solutions"
            period="Nov 2021 – Aug 2025"
            photo={img7}
            description="Designed user-centered experiences for enterprise and B2B SaaS platforms, focusing on workflows, dashboards, and system usability."
          />
        </section>

        {/* ══ PREVIOUSLY ══ */}
        <section style={{ paddingTop: 48 }}>
          <span className="sec-label">Previously</span>
          <ExpRow
            logo={logoAnnapurna}
            company="Annapurna"
            role="Visual Effect Artist at Annapurna Studios"
            period="Feb 2019 – Nov 2021"
            photo={img6}
            description="Worked on visual effects projects combining creativity and technical execution for high-quality digital media storytelling."
          />
        </section>

        <hr className="divider" style={{ marginTop: 14 }} />

        {/* ══ TOOLS ══ */}
        <section ref={toolsRef} className="reveal" style={{ paddingTop: 52, paddingBottom: 64 }}>
          <span className="sec-label">Tools that help me in</span>
          <div className="tools-grid">
            {toolGroups.map((g) => <ToolCard key={g.category} {...g} />)}
          </div>
        </section>

      </main>

  

    </div>
  );
}